export const ORDER_EXECUTION_POLL_INTERVAL_MS = 3_000;
export const ORDER_EXECUTION_DELAYED_AFTER_MS = 2 * 60 * 1_000;
export const ORDER_EXECUTION_POLL_TIMEOUT_MS = 10 * 60 * 1_000;
export const ORDER_EXECUTION_POLL_BLOCK_OVERLAP = 5;

export type OrderExecutionPollingPhase = "active" | "delayed" | "timed-out";

export function getOrderExecutionPollingPhase(elapsedMs: number): OrderExecutionPollingPhase {
  if (elapsedMs >= ORDER_EXECUTION_POLL_TIMEOUT_MS) {
    return "timed-out";
  }

  if (elapsedMs >= ORDER_EXECUTION_DELAYED_AFTER_MS) {
    return "delayed";
  }

  return "active";
}

export function getNextOrderExecutionFromBlock({
  initialFromBlock,
  scannedToBlock,
  overlapBlocks = ORDER_EXECUTION_POLL_BLOCK_OVERLAP,
}: {
  initialFromBlock: number;
  scannedToBlock: number;
  overlapBlocks?: number;
}) {
  return Math.max(initialFromBlock, scannedToBlock - overlapBlocks + 1);
}
